import Logo from '@/../../public/storage/Logo.webp';
import { Card, CardHeader, CardContent } from '@/components/ui/card';
import Typography from '@/components/ui/typography';
import { Link } from '@inertiajs/react';
import { Toaster } from 'sonner';

const AdminAuthLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <div className="flex flex-col items-center justify-between min-h-screen bg-surface">
        <div className="flex flex-1 w-full items-center justify-center">
          <Card className="w-11/12 max-w-96 shadow-card">
            <CardHeader>
              <div className="flex items-center justify-center">
                <Link href={route('admin.login')}>
                  <img
                    className="h-24 w-auto object-cover"
                    alt="Samuthrika Academy Logo"
                    src={Logo}
                  />
                </Link>
              </div>
            </CardHeader>
            <CardContent>{children}</CardContent>
          </Card>
        </div>
        <footer className="pb-4 w-full">
          <div className="flex flex-wrap gap-y-2 items-center justify-around">
            <Typography.Subtle>
              © {new Date().getFullYear()} Samuthrika Academy. All rights
              reserved.
            </Typography.Subtle>
            <Typography.Subtle>
              Designed & Developed By{' '}
              <a
                href="https://www.linkedin.com/in/praveen-saravanan-99688b128"
                target="_blank"
                rel="noopener noreferrer"
                className="underline decoration-1 underline-offset-4"
              >
                Praveen Saravanan
              </a>
            </Typography.Subtle>
          </div>
        </footer>
      </div>
      <Toaster richColors theme="light" />
    </>
  );
};

export default AdminAuthLayout;
